module.exports = __webpack_public_path__ + "img/icon-location-purple.96732f6d.svg";